import { syncTaskFactory } from '../../syncTask';
import { mySegmentsFetcherFactory } from '../fetchers/mySegmentsFetcher';
import { mySegmentsUpdaterFactory } from '../updaters/mySegmentsUpdater';
/**
 * Creates a sync task that periodically executes a `mySegmentsUpdater` task
 */
export function mySegmentsSyncTaskFactory(fetchMemberships, storage, readiness, settings, matchingKey) {
    return syncTaskFactory(settings.log, mySegmentsUpdaterFactory(settings.log, mySegmentsFetcherFactory(fetchMemberships), storage, readiness.segments, settings.startup.requestTimeoutBeforeReady, settings.startup.retriesOnFailureBeforeReady, matchingKey), settings.scheduler.segmentsRefreshRate, 'mySegmentsUpdater');
}
